import React from 'react';
import {
  Route,
  Redirect,
} from 'react-router-dom';
import { connect } from 'react-redux';

function LoggedOutRoute({ children, ...rest }) {
  const { isAuthenticated } = rest;
  return (
    <Route
      {...rest}
      render={
        ({ location }) => (!isAuthenticated ? (children) : (<Redirect to={{ pathname: '/customer/repairs', state: { from: location } }} />))
}
    />
  );
}
function mapStateToProps(state) {
  const { AuthReducer } = state;
  const { isAuthenticated } = AuthReducer;
  return {
    isAuthenticated,
  };
}
export default connect(mapStateToProps)(LoggedOutRoute);
